export enum TabType {
	basic = 0,
	big = 1,
}
